import { render, staticRenderFns } from "./sa-organization-list.html?vue&type=template&id=8dcdfd24&scoped=true&"
import script from "./sa-organization-list.js?vue&type=script&lang=js&"
export * from "./sa-organization-list.js?vue&type=script&lang=js&"
import style0 from "./sa-organization-list.scss?vue&type=style&index=0&id=8dcdfd24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcdfd24",
  null
  
)

export default component.exports